import emberRpc from '@square/ember-rpc-client';
import { ConsoleLoggerFactory, ConnectError, parseResponse } from '@square/ember-rpc-client/utils';
import environment from '@square/environment-utils/environment';
import { getUrlFlag } from '@square/dashboard-utilities/utils/window';
const logrpc = Boolean(getUrlFlag('logrpc', location));
const env = environment();
const loggingEnabled = env.isDevelopment || env.isStaging || logrpc;
export default function rpc(urlForMethod, headers) {
  return emberRpc({
    urlForMethod,
    loggerFactory: new ConsoleLoggerFactory(loggingEnabled),
    errorDeserializer: ConnectError.fromResponse,
    additionalHeaders: headers,
    responseParser: parseResponse,
    sendSpeleoTraceId: false
  });
}